import React, { useState } from "react";
import "./Carousel.css";

import FadeInAnimation from "components/FadeInAnimation";

const Carousel = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setCurrentIndex(selectedIndex);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  return (
    <div className="carousel-container">
      {/* Slide Content */}
      <div className="carousel-slide">
        {slides.map((slide, index) => (
          <div key={index} className={`carousel-item ${currentIndex === index ? "active" : ""}`}>
            {slide.content}
          </div>
        ))}
      </div>

      <div className="carousel-arrows">
        <div className="carousel-dots">
          {slides.map((_, index) => (
            <button key={index} className={`dot ${currentIndex === index ? "active" : ""}`} onClick={() => handleSelect(index)} />
          ))}
        </div>
        <button className="arrow left" onClick={prevSlide}>
          ◀
        </button>
        <button className="arrow right" onClick={nextSlide}>
          ▶
        </button>
      </div>
    </div>
  );
};

export default Carousel;
